import { TrustPilotModal } from "@origin-digital/platform-personalisation";
import * as React from "react";
import { useEffect } from "react";
import {
  CrisisBanner,
  isCrisisBannerPreview,
} from "@origin-digital/crisis-banner";
import { SkipLink } from "../../components/SkipLink";
import { SuppressAndroidInstallPrompt } from "../../components/SuppressAndroidInstallPrompt";

import Breadcrumbs, {
  getBreadcrumbsContent,
} from "../../components/Breadcrumbs";
import { InAppMessagingService } from "../../components/InAppMessagingService";
import { PrefetchContext } from "../../components/prefetch";
import RootWrapper from "../../components/RootWrapper";
import { configNRLogger } from "../../client/configNR";

import type { AppProps } from "../types";
import { KrakenAppContent } from "./AppContent";

const AuthApp = ({
  actionBar,
  authenticated,
  channel,
  prefetchContent = {},
  showHeader = true,
  showNativeAppAd = true,
  crisisBanner = "none",
  title,
  storyMode = false,
}: AppProps) => {
  useEffect(() => {
    // Needs to be done here to ensure it has access to window.oetal
    configNRLogger();
  }, []);

  const isNativeChannel = channel === "native";
  const breadcrumbsContent = getBreadcrumbsContent(prefetchContent);
  const isPreview = typeof window !== "undefined" && isCrisisBannerPreview();
  let crisisBannerPosition = crisisBanner;

  if (isPreview) {
    crisisBannerPosition = "top";
  }

  if (storyMode && authenticated) {
    // Match the authenticated page data TAL normally supplies outside Storybook.
    window.oetal.pageData.authenticated = true;
  }

  const AppContent = (
    <PrefetchContext.Provider value={prefetchContent}>
      <TrustPilotModal />
      <InAppMessagingService />
      {!showNativeAppAd && <SuppressAndroidInstallPrompt />}
      {crisisBannerPosition !== "float" && !isNativeChannel && (
        <CrisisBanner position={crisisBannerPosition} />
      )}

      <SkipLink target="#oetal-application-root" />
      <KrakenAppContent
        title={title}
        showHeader={showHeader}
        actionBar={actionBar}
        crisisBanner={crisisBannerPosition}
        isNative={isNativeChannel}
      />

      {crisisBannerPosition !== "top" && !isNativeChannel && (
        <CrisisBanner position={crisisBannerPosition} />
      )}
      {breadcrumbsContent && <Breadcrumbs data={breadcrumbsContent} />}
    </PrefetchContext.Provider>
  );

  return storyMode ? AppContent : <RootWrapper>{AppContent}</RootWrapper>;
};

export { AuthApp };
